import React from 'react';
import '../styles/Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-logo">Brilliant Beauty</div>
            <p className="footer-text">
                &copy; 2026 Brilliant Beauty Calgary, AB.
            </p>
            </footer>
    );
}

export default Footer;